import { SuperAdminService } from "services/superAdminService";

class BookCategoriesSAService extends SuperAdminService<any> {
  constructor() {
    super("book-categories");
  }
}
export default new BookCategoriesSAService();
